import React from "react";

import Typography from "@material-ui/core/Typography";
import styled from "styled-components/macro";

import Card from "components/Card";
import { Chip } from "components/Chip";
import { Row } from "components/Layout";

const ResolvedCard = styled(Card)`
  margin: ${({ theme }) => `${theme.space[1]}px ${theme.space[2]}px`};
  border-left: 4px solid ${({ theme }) => theme.colors.successGreen};
`;

const ClickableResolvedCard = styled(ResolvedCard)`
  cursor: pointer;
  transition: ${({ theme }) => theme.transitions[0]};
  &:hover {
    filter: brightness(0.97);
  }
`;

interface ResolvedBusinessProps {
  name: string;
  resolution: string;
  // Opens the Business it became.
  onClick?: () => void;
}

export function ResolvedBusiness({
  name,
  resolution,
  onClick,
}: ResolvedBusinessProps) {
  const CardComponent = onClick ? ClickableResolvedCard : ResolvedCard;
  return (
    <CardComponent fullWidth onClick={onClick}>
      <Row alignCenter justifyBetween flexWrap>
        <Typography>{name}</Typography>
        <Chip color="black" backgroundColor="successGreen">
          {resolution}
        </Chip>
      </Row>
    </CardComponent>
  );
}
